import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import bonusService from '../../services/bonus';

const initialState = {
  loading: false,
  bonus: [],
  error: '',
  params: {
    page: 1,
    perPage: 10,
  },
  meta: {},
};

function normalizeListPayload(payload) {
  const rows = payload?.data ?? [];
  const p = payload?.pagination;
  const m = payload?.meta;
  if (p) {
    return {
      data: rows,
      meta: {
        total: p.total ?? 0,
        current_page: p.page ?? 1,
        per_page: p.perPage ?? 10,
      },
    };
  }
  if (m) {
    return {
      data: rows,
      meta: {
        total: m.total ?? 0,
        current_page: m.current_page ?? m.page ?? 1,
        per_page: m.per_page ?? m.perPage ?? 10,
      },
    };
  }
  return { data: rows, meta: { total: rows.length, current_page: 1, per_page: 10 } };
}

export const fetchBonusList = createAsyncThunk(
  'bonusList/fetchBonusList',
  (params = {}) => {
    return bonusService
      .listRules({ ...initialState.params, ...params })
      .then((res) => res);
  }
);

const bonusListSlice = createSlice({
  name: 'bonusList',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchBonusList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchBonusList.fulfilled, (state, action) => {
      const { payload } = action;
      state.loading = false;
      const { data, meta } = normalizeListPayload(payload);
      state.bonus = data;
      state.meta = meta;
      state.params.page = meta.current_page;
      state.params.perPage = meta.per_page;
      state.error = '';
    });
    builder.addCase(fetchBonusList.rejected, (state, action) => {
      state.loading = false;
      state.bonus = [];
      state.error = action.error.message;
    });
  },
});

export default bonusListSlice.reducer;
